module.exports = __webpack_public_path__ + "img/mail.088bc64c.svg";